<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
  <div class="member-search-page-wrapper"
    #scrollElement>
    <div
      class="form-wrapper" style="flex: 0 0 90%; max-width: 90%">

      <!-- Search form -->
      @if (showSearchForm) {
        <div>
          <form class="d-flex flex-column" [formGroup]="formGroup">
            <div class="d-flex flex-sm-column flex-row bottin-row" >
              <div class="dropdownColumn">
                <!-- Search by name and permit number -->
                <odq-board-member-search [public]="true" 
                formControlName="member"></odq-board-member-search>
              </div>
              <div class="dropdownColumn">
                <!-- municipality -->
                <mat-form-field
                  appearance="outline" style="width: 100%; height: 100%">
                  <mat-label>
                    {{ 'publicMemberSearch.municipality' | translate }}
                  </mat-label>
                  <input type="text"
                    matInput
                    formControlName="municipality"
                    [matAutocomplete]="municipalityAutoComp">
                    @if (formGroup.get('municipality').value) {
                      <button class="clearFieldButton"
                        type="button"
                        mat-icon-button
                        (click)="clearInput('municipality')">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    <mat-autocomplete #municipalityAutoComp="matAutocomplete"
                      [displayWith]="displayMunicipality">
                      @for (option of filteredMunicipalitys$ | async; track option) {
                        <mat-option
                          [value]="option">
                          {{option.name}} - {{option.provinceName}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (formGroup.controls['municipality'].hasError('incorrect')) {
                      <mat-error>
                        {{'form.validation.selectionRequired' | translate}}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex bottin-row">
                <div class="dropdownColumn">
                  <!-- speciality -->
                  <mat-form-field appearance="outline" style="width: 100%; height: 100%">
                    <mat-label>
                      {{ 'publicMemberSearch.speciality' | translate }}
                    </mat-label>
                    <input type="text"
                      matInput
                      formControlName="speciality"
                      [matAutocomplete]="specialityAutoComp">
                      @if (formGroup.get('speciality').value) {
                        <button class="clearFieldButton"
                          type="button"
                          mat-icon-button
                          (click)="clearInput('speciality')">
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      <mat-autocomplete #specialityAutoComp="matAutocomplete"
                        [displayWith]="displaySpecialtyBinded">
                        @for (option of filteredSpecialities$ | async; track option) {
                          <mat-option
                            [value]="option">
                            {{option.description[translate.currentLang] }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      @if (formGroup.controls['speciality'].hasError('incorrect')) {
                        <mat-error>
                          {{'form.validation.selectionRequired' | translate}}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="dropdownColumn">
                    <!-- administrative region -->
                    <mat-form-field
                      appearance="outline" style="width: 100%; height: 100%">
                      <mat-label>
                        {{ 'publicMemberSearch.administrativeRegion' | translate }}
                      </mat-label>
                      <input type="text"
                        matInput
                        formControlName="administrativeRegion"
                        [matAutocomplete]="administrativeRegionAutoComp">
                        @if (formGroup.get('administrativeRegion').value) {
                          <button class="clearFieldButton"
                            type="button"
                            mat-icon-button
                            (click)="clearInput('administrativeRegion')">
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                        <mat-autocomplete #administrativeRegionAutoComp="matAutocomplete"
                          [displayWith]="displayAdministrativeRegion">
                          @for (option of filteredAdministrativeRegions$ | async; track option) {
                            <mat-option
                              [value]="option">
                              {{ option.description }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                        @if (formGroup.controls['administrativeRegion'].hasError('incorrect')) {
                          <mat-error>
                            {{'form.validation.selectionRequired' | translate}}
                          </mat-error>
                        }
                      </mat-form-field>
                  </div>
              </div>
                  <fieldset class="d-flex flex-column">
                    <legend>
                      {{ 'publicMemberSearch.memberSpecification' | translate }}
                    </legend>
                    <div class="specification-row">
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isAnesthesiaPrivateClinic' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isAnesthesiaPrivateClinic"></mat-checkbox>
                        </div>
                      </div>
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isParticularMedicalCondition' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isParticularMedicalCondition"></mat-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="specification-row">
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isAnesthesiaHospital' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isAnesthesiaHospital"></mat-checkbox>
                        </div>
                      </div>
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isSleepApnea' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isSleepApnea"></mat-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="specification-row">
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isHomeVisit' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isHomeVisit"></mat-checkbox>
                        </div>
                      </div>
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isReducedMobility' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input" class="specification-input">
                          <mat-checkbox formControlName="isReducedMobility"></mat-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="specification-row">
                      <div class="bottin-50">
                        <div class="specification-label">
                          <mat-label>
                            {{ 'publicMemberSearch.isLiftPerson' | translate }}
                          </mat-label>
                        </div>
                        <div class="specification-input">
                          <mat-checkbox formControlName="isLiftPerson"></mat-checkbox>
                        </div>
                      </div>
                      <!--fill the void-->
                      <div class="bottin-50"></div>
                    </div>
                  </fieldset>
                </form>
              </div>
            }

            <!-- Selected member infos -->
            @if (showMemberinfoBox) {
              <div class="member-infos"
                >
                @if (memberPublicInfosLoading$|async) {
                  <div>
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else {
                  <odq-public-member-info-v2 [memberPublicInfos]="memberPublicInfos$ | async"
                    [insuranceStatusCodes]="insuranceStatusCodes$ | async"
                  [specialtytypes]="specialities$ | async"></odq-public-member-info-v2>
                }
              </div>
            }

            <!-- Search results -->
            @if (showResultList) {
              <div class="member-list"
                >
                <h2>{{ 'publicMemberSearch.searchResults' | translate }}</h2>
                <h4>{{ 'publicMemberSearch.criterias' | translate}}</h4>
                <h4>{{ displaySpecialty(selectedSpecialty) }}</h4>
                <h4>{{ displayMunicipality(selectedMunicipality) }}</h4>
                <h4>{{ displayAdministrativeRegion(selectedAdministrativeRegion) }}</h4>
                <h4>{{ displayIsAnesthesiaPrivateClinic() }}</h4>
                <h4>{{ displayIsAnesthesiaHospital() }}</h4>
                <h4>{{ displayIsParticularMedicalCondition() }}</h4>
                <h4>{{ displayIsHomeVisit() }}</h4>
                <h4>{{ displayIsSleepApnea() }}</h4>
                <h4>{{ displayIsReducedMobility() }}</h4>
                <h4>{{ displayIsLiftPerson() }}</h4>
                @if ((searching$ | async)) {
                  <div>
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else {
                  <div class="d-flex flex-wrap member-search-results" >
                    @for (member of members$|async ; track member) {
                      <div class="member-search-result-item"
                        >
                        <a  href=""
                        (click)="selectMember($event,member.id)">{{ member.lastName + ', ' + member.firstName + ' - ' + member.permitNumber}}</a>
                      </div>
                    }
                  </div>
                  @if ((members$ | async).length === 0) {
                    <div>
                      {{ 'publicMemberSearch.noResult' | translate }}
                    </div>
                  }
                }
              </div>
            }

            <div class="buttons">
              @if (!showSearchForm) {
                <button mat-flat-button
                  color="primary"
                  class="bottin bottin-btn"
                  (click)="newSearch()">
                  {{ 'publicMemberSearch.newSearch' | translate}}
                </button>
              }
              @if (showSearchForm) {
                <button mat-flat-button
                  color="primary"
                  class="bottin "
                  (click)="search()"
                  [disabled]="searchIsDisabled"
                  >
                  {{ 'publicMemberSearch.search' | translate}}
                </button>
              }
              @if (fromSearch) {
                <button mat-flat-button
                  color="primary"
                  class="ml-2 bottin bottin-btn"
                  (click)="search()">
                  {{ 'publicMemberSearch.backToResults' | translate}}
                </button>
              }
            </div>
          </div>
          <div class="empty-space"></div>
        </div>
      </div>
